import React, { useState, useEffect } from "react";
import "react-dates/initialize";
import "react-dates/lib/css/_datepicker.css";
import Samples from "../sample_reporting/Samples";
import Button from "../Button";
import { DateRangePicker } from "react-dates";
import { fetchJson } from "../../lib/Fetching";
import moment from "moment";

export default function TestBedQueryParameters({ id }) {
  const [startDate, setStartDate] = useState(moment());
  const [endDate, setEndDate] = useState(moment());
  const [focusedInput, setFocusedInput] = useState(false);
  const [sampleList, setSampleList] = useState(null);

  const loadSamples = () => {
    setSampleList(null);
    fetchJson("/result_notifications/test_query_parameters/" + id + "/sample_list", {
      start_date: startDate ? startDate.format("YYYY-MM-DD") : null,
      end_date: endDate ? endDate.format("YYYY-MM-DD") : null,
    }).then((json) => setSampleList(json.sample_list));
  };

  return (
    <div className="panel">
      <DateRangePicker
        startDateId="start_date"
        startDate={startDate}
        endDateId="end_date"
        endDate={endDate}
        numberOfMonths={1}
        onDatesChange={({ startDate, endDate }) => {
          setStartDate(startDate);
          setEndDate(endDate);
        }}
        focusedInput={focusedInput}
        onFocusChange={(focused) => setFocusedInput(focused)}
        showClearDates={true}
        isOutsideRange={() => false}
        hideKeyboardShortcutsPanel={true}
        displayFormat="DD MMM YYYY"
        minimumNights={0}
      />
      <Button title="Find Samples" onClick={loadSamples} disabled={!startDate || !endDate} />
      {sampleList && (
        <div style={{ marginTop: 20 }}>
          <Samples
            view="sample_notifications"
            sample_list={sampleList}
            showAttributes={false}
            clientView={false}
          />
        </div>
      )}
    </div>
  );
}
